export const ja = {
  nav: {
    pillars: "活動内容", network: "ネットワーク", wrd: "世界ルバーブの日", knowledge: "ナレッジ",
    transparency: "透明性", join: "協会に参加", brandTop: "World Rhubarb", brandBottom: "Association",
  },
  footer: {
    tagline: "ルバーブ産業を育てる人と組織をつなぐ、グローバルネットワーク。",
    ledger: ["ステータス: 創設フェーズ", "創設: 2026年", "Founder / 代表: 須藤亘平(Kohei Sudo)", "コアチーム: 2名 · 外部メンバー: 0名", "法人格: なし(任意団体)"],
    orgTitle: "組織",
    orgLinks: ["ビジョンとミッション", "ロードマップ", "透明性", "お問い合わせ"],
    initTitle: "イニシアチブ",
    initLinks: ["世界ルバーブの日", "市場拡大", "ナレッジハブ", "グローバルデータベース"],
    refTitle: "参考モデル",
    copyright: "© 2026 World Rhubarb Association",
    verified: "検証済みデータのみ · 架空の数字はありません",
  },
  hero: {
    kicker: "World Rhubarb Association — 2026年創設",
    h1a: "ルバーブで", h1bPre: "", h1b: "世界を", h1c: "つなぐ。",
    para: "世界中のルバーブ生産者・研究者・企業・愛好家をつなぎ、ルバーブ産業の発展と、持続可能な未来を創ります。",
    ctaJoin: "協会に参加する", ctaActivities: "活動内容を見る",
    stats: [["創設", "2026"], ["コアチーム", "2名"]],
    statMembers: "登録メンバー", statCountries: "参加国",
    statsNote: "創設時点の実数 · ネットワークの成長に合わせて更新します",
    specimen: "標本 · 露地栽培のルバーブ畑",
  },
  marquee: ["Rheum rhabarbarum", "2026年創設", "創設ネットワーク構築中", "誇張ゼロ", "生産者 · 研究者 · シェフ", "世界ルバーブの日イニシアチブ", "検証済みデータのみ"],
  pillars: {
    kicker: "私たちの活動",
    title: "6つの活動。すべてオープンに進めます。",
    items: [
      { title: "生産者をつなぐ", text: "世界各国のルバーブ生産者をつなぎ、情報交換・協力・販路開拓を促進します。", tags: ["情報交換", "協力", "販路開拓"] },
      { title: "市場を拡大する", text: "ルバーブの新しい用途・商品・市場を開拓し、世界的な需要を広げます。", tags: ["新しい用途", "商品開発", "世界的な需要"] },
      { title: "新規生産者を支援する", text: "新しく栽培を始める生産者に、栽培情報・先行事例・市場情報を提供します。", tags: ["栽培情報", "先行事例", "市場情報"] },
      { title: "調査とデータ", text: "世界のルバーブ生産・流通・品種・市場に関する情報を収集し、データベース化します。", tags: ["生産", "品種", "市場データ"] },
      { title: "国際連携", text: "各国の団体、大学、研究者、企業、行政などとの国際的な連携を築きます。", tags: ["団体", "大学", "行政"] },
      { title: "世界ルバーブの日", text: "ルバーブの認知度向上のため、「世界ルバーブの日」の制定と普及を目指します。", tags: ["認知向上", "制定", "世界的な祝日"] },
    ],
  },
  network: {
    kicker: "私たちのグローバルネットワーク",
    titleA: "いま私たちは、", titleAccent: "創設ネットワークを築いています。",
    para: "いまネットワークは、2名の創設チームだけ。ここから加わるのは、参加に正式に同意した実在の個人と団体だけです。同意なく名前を載せることは、決してありません。",
    stages: [
      { stage: "創設チーム", note: "2026年 · 2名 · 現在活動中", state: "active" },
      { stage: "創設ネットワーク", note: "構築中 — 参加を受付中", state: "building" },
      { stage: "国際ネットワーク", note: "各国に広がるメンバー", state: "future" },
      { stage: "グローバル産業プラットフォーム", note: "長期的な到達点", state: "future" },
    ],
    stateLabels: { active: "現在", building: "構築中", future: "将来" },
    mapKicker: "グローバルネットワークマップ",
    globeNote: "ノードは開放中の地域を示します · ネットワーク状況: 創設フェーズ",
    chapterNote: "各国支部 — 未設立",
    regionStatus: "カントリー代表 — 募集中",
    regions: ["東・東南アジア", "ヨーロッパ", "北米", "南米", "アフリカ", "オセアニア"],
    regionsNote: "加盟国数: 0。支部は正式な任命があってから初めてここに掲載します。それ以前に載せることは決してありません。",
  },
  manifesto: {
    kicker: "私たちが存在する理由 — 3章のマニフェスト",
    chapters: [
      { title: "見過ごされてきた多年草", text: "ヨークシャーの促成栽培小屋から北海道の畑まで——ルバーブは何世紀にもわたって人々の食卓を彩ってきました。それなのに、世界規模の声も、共有されるデータも、ひとつにまとまった産業もありません。価値は本物。でも、散らばったままです。" },
      { title: "分断された産業", text: "生産者も、研究者も、シェフも、食品企業も、それぞれが孤立して活動しています。知識は組織ごとに閉じ、市場情報は点在するか、そもそも存在しない。ピースをつなぐ役目を、誰も担っていません。" },
      { title: "2人からプラットフォームへ", text: "WRAは、正直な現在地から始まります。2026年、2名の創設チーム、外部メンバー0名、パートナー0。規模を「偽る」のではなく「獲得する」——2人から創設ネットワークへ、国際ネットワークへ、そして世界のルバーブ産業のプラットフォームへ。" },
    ],
  },
  mission: {
    kicker: "ビジョンとミッション", visionLabel: "ビジョン", missionLabel: "ミッション",
    vision: "ルバーブの経済的・文化的な価値が世界で十分に実現され、それを育て、研究し、調理し、販売するすべての人がつながっている世界。",
    items: [
      "認知向上・商品開発・市場情報の共有で世界のルバーブ市場を広げ、その担い手となる生産者を確保・支援する。",
      "生産者、研究者、企業、愛好家からなる国際ネットワークを築く。",
      "「世界ルバーブの日」を国際的に認められる記念日として制定することを目指す。",
    ],
  },
  who: {
    kicker: "参加できる方",
    title: "7つの立場の人が、産業を育てる。",
    items: [
      { title: "生産者", text: "世界各国のルバーブ生産者——露地・促成、大規模・小規模、これから始める人も。" },
      { title: "研究者", text: "植物科学・農学・食品科学の大学・研究機関。" },
      { title: "食品企業", text: "メーカー、加工業者、商品開発企業。" },
      { title: "シェフ", text: "ルバーブ料理を形づくるレストランや料理人。" },
      { title: "小売・流通", text: "小売、流通、輸出入の事業者。" },
      { title: "農業団体", text: "生産者団体、地域団体、協同組合。" },
      { title: "愛好家", text: "家庭で育てる人、料理を楽しむ人、ルバーブを愛するすべての人。" },
    ],
    ctaCard: "どの立場でも——ネットワークはあなたから始まります。",
    cta: "ネットワークに参加",
  },
  membership: {
    kicker: "メンバーシップ",
    titleA: "創設ネットワーク — ", titleAccent: "現在構築中です。",
    para: "現在、外部メンバーは0名です。名簿をでっち上げるのではなく、まずルールを公開します。正式なメンバーシップポリシーを策定中で、最初のメンバーを掲載する前に、透明性ページで公開します。",
    principles: [
      { t: "同意第一の掲載", d: "名前・国・役職は、正式な書面での同意がある場合のみ公開します。" },
      { t: "ガバナンスは整備中", d: "諮問委員会・委員会・カントリー代表は計画中の構造であり、まだ誰も就任していません。" },
      { t: "開かれたカテゴリー", d: "生産者、研究者、企業、シェフ、小売、農業団体、愛好家。" },
    ],
    specimen: "標本 · 生産者市場で束ねられた新鮮な茎",
  },
  whyJoin: {
    kicker: "創設ネットワークに参加する理由",
    title: "いま参加する、6つの理由。",
    items: [
      { title: "国際的なつながり", text: "世界各国のルバーブ生産者、研究者、企業、団体とつながれます。" },
      { title: "創設メンバーの称号", text: "創設フェーズに参加した「創設メンバー」として認められます。" },
      { title: "ディレクトリへの掲載", text: "グローバルメンバーディレクトリへの掲載は任意——あなたが選んだ場合のみです。" },
      { title: "知識の国際交流", text: "栽培・市場・研究の知識を、国際的に交換できます。" },
      { title: "国際ミーティング", text: "将来のオンライン国際ミーティングに参加できる機会があります。" },
      { title: "コラボレーションの機会", text: "研究・ビジネスなどの協業につながる可能性があります。" },
    ],
    note: "創設フェーズの会費は無料で、世界中どこからでも参加できます。これらの特典は機会を示すものであり、保証ではありません。",
    cta: "創設ネットワークに参加",
  },
  market: {
    kicker: "柱 I — 市場拡大",
    titleA: "市場拡大を、", titleAccent: "具体的に。",
    items: [
      { title: "消費者認知", text: "ルバーブとは何か、世界のルバーブ料理、歴史、品種、栽培、旬、レシピ——世界の読者に向けて発信します。", alt: "カーマインのグラデーションのルバーブの茎" },
      { title: "商品開発", text: "ジャム、ソース、飲料、デザート、ベーカリー、発酵食品、調味料、菓子、非食品用途まで。科学的な根拠のない健康効果の主張は、決してしません。", alt: "束ねられた新鮮なルバーブの茎" },
      { title: "生産者の確保とマッチング", text: "各地域がルバーブ生産者を確保し、育てていくための支援。そして将来の生産者ディレクトリと企業ディレクトリで、生産者は原料を提供し、企業は商品を開発し、レストランはメニューを作れるようにします。", alt: "露地のルバーブ畑" },
      { title: "市場データ", text: "世界ルバーブ市場データベース——生産量、品種、旬、貿易。データが存在しない項目には「データなし」と正直に表示します。", alt: "農業研究の標本" },
    ],
  },
  international: {
    kicker: "柱 II — 国際ネットワーク",
    title: "ネットワークは、順を追って築かれる。",
    items: [
      { t: "創設ネットワーク", d: "現在構築中。招待と応募による正式な参加——確認された参加者だけを掲載します。" },
      { t: "国際アウトリーチ", d: "世界各国の生産者、団体、大学、研究者、食品企業、シェフ、小売への参加呼びかけ。新しい産地が最初の生産者を確保する支援も含みます。" },
      { t: "カントリー代表", d: "国ごとに一定数のメンバーが集まった段階で導入します。正式な任命があった場合のみ掲載します。" },
      { t: "各国支部", d: "WRA Japan、WRA UK、WRA Poland などの将来の構造。WRAとの関係を明確に公開した上で設立します。" },
      { t: "国際会議", d: "オンラインミーティング、ウェビナー、研究セミナー、生産者会議、そしていずれは国際会議を開催します。" },
    ],
  },
  wrd: {
    kicker: "柱 III — 世界ルバーブの日",
    badge: "イニシアチブ · 提案中 — まだ公式ではありません",
    titleA: "ルバーブの世界的な祝日を——", titleAccent: "宣言するのではなく、実績で獲得する。",
    para: "「世界ルバーブの日」を、ルバーブとその生産者、文化、未来を祝う、国際的に認められた日にすることを目指しています。プロセスは公開です。調査、提案、賛同、各国オーガナイザー、そしてグローバルキャンペーン。",
    cta1: "イニシアチブを見る", cta2: "世界ルバーブの日を支援",
    phases: [
      { p: "フェーズ1", t: "調査と提案", d: "歴史・文化・旬・ふさわしい日程について、世界にヒアリング。" },
      { p: "フェーズ2", t: "国際的な賛同", d: "生産者・大学・団体・シェフからの賛同——同意を得て公開。" },
      { p: "フェーズ3", t: "各国オーガナイザー", d: "各国の代表・支部が、それぞれの地域で推進。" },
      { p: "フェーズ4", t: "グローバルキャンペーン", d: "イベント、フェア、コンテスト、教育——世界規模で。" },
    ],
  },
  knowledge: {
    kicker: "ルバーブ・ナレッジハブ",
    titleA: "引用に値する", titleAccent: "知識を。",
    para: "エビデンスに基づくライブラリを準備しています。記事は可能な限り、大学の研究、政府機関、農業団体、査読付き論文を引用します。",
    statusLabel: "ライブラリ状況",
    statusText: "2026年に収集開始。記事は情報源を明記して、順次公開します。",
    categories: ["栽培", "品種", "植物科学", "食品科学", "加工", "サステナビリティ", "経済", "歴史", "文化"],
    catNote: "準備中",
  },
  database: {
    kicker: "グローバル・ルバーブ・データベース",
    titleA: "今日は空。", titleAccent: "常に誠実に。",
    para: "WRAの長期的なデータ資産——世界のルバーブ産業の、検証済みの記録です。架空の数字はありません。検証済みデータがない項目は「データなし」と表示されます。",
    badge: "データなし",
    items: [
      { name: "国", desc: "国別のルバーブ情報" },
      { name: "生産者", desc: "生産者レジストリ" },
      { name: "品種", desc: "品種の記録" },
      { name: "研究者", desc: "学術ネットワーク" },
      { name: "企業", desc: "食品・加工企業" },
      { name: "団体", desc: "関連団体" },
      { name: "イベント", desc: "世界のルバーブイベント" },
      { name: "研究", desc: "研究と情報源" },
    ],
  },
  roadmap: {
    kicker: "ロードマップ", title: "2026 → 2030",
    disclaimer: "長期的なビジョン — 確定した予定ではありません", now: "現在",
    items: [
      { year: "2026", title: "基盤", items: ["WRA始動", "初期チームの形成", "国際アウトリーチ開始"], active: true },
      { year: "2027", title: "グローバルネットワーク", items: ["創設メンバー", "国際的な生産者・研究者", "カントリー代表"] },
      { year: "2028", title: "知識とデータ", items: ["グローバル・ルバーブ・データベース", "ルバーブ・ナレッジハブ", "研究ネットワーク"] },
      { year: "2029", title: "市場開発", items: ["生産者×企業マッチング", "国際的な商品開発", "世界市場調査"] },
      { year: "2030", title: "世界ルバーブの日", items: ["グローバルキャンペーン", "国際イベント", "国レベルの祝典"] },
    ],
  },
  join: {
    kicker: "ムーブメントに参加",
    titleA: "", titleAccent: "創設ネットワーク", titleB: "のメンバーになる",
    para: "WRAは2026年、2名の創設チームで動き始めました。ここから先は、次に参加してくれる人々と一緒に作ります。まずは関心をご登録ください。創設メンバーシップの仕組みが整い次第、ご連絡します。",
    bullets: [
      "確認された参加者のみ、同意の上で掲載します",
      "会費は未設定——ポリシーを先に公開します",
      "生産者、研究者、シェフ、企業、愛好家、どなたでも歓迎です",
    ],
    formTitle: "創設ネットワーク — 参加意向の登録",
    ph: { name: "お名前 *", email: "メールアドレス *", country: "国", org: "所属組織(任意)", message: "どのように貢献したいか(任意)" },
    categoryPh: "あなたは… *",
    categories: ["生産者", "研究者・大学", "食品企業", "シェフ・レストラン", "小売・流通", "農業団体", "愛好家", "その他"],
    submit: "ネットワークに参加", submitting: "送信中…",
    note: "参加意向として記録されます。正式なメンバーシップは、ポリシー公開後に開始します",
    thanks: "ありがとうございます",
    success: "確認リンクをメールでお送りしました。リンクをクリックすると、登録が完了します。",
    toastOk: "参加意向を記録しました。",
    toastErr: "送信に失敗しました。もう一度お試しください。",
  },
  wrdPage: {
    kicker: "世界ルバーブの日イニシアチブ",
    badge: "提案中 · キャンペーン準備中",
    h1a: "世界", h1b: "ルバーブ", h1c: "の日",
    sub: "ルバーブと、その生産者、その文化、その未来を祝う、世界的な日を。",
    para: "「世界ルバーブの日」を、国際的に認められる記念日として制定することを目指しています。まだ公式の日ではありません——このページは、その承認を獲得していくオープンなプロセスを記録しています。",
    cta: "イニシアチブを支援する",
    specimen: "標本 · 鮮やかなカーマインのルバーブの茎",
    why: {
      kicker: "なぜ世界ルバーブの日なのか?",
      items: [
        { title: "文化的遺産", text: "英国の促成栽培小屋からアジアの薬用伝統、現代の北欧のキッチンまで——ルバーブは何世紀もの食文化を担ってきました。共に認め合う瞬間に値する作物です。" },
        { title: "生産者への敬意", text: "生産者を一番に据える日。世界で最も個性的な作物のひとつを植え、促成し、収穫し、束ねる人々を讃えます。" },
        { title: "季節のガストロノミー", text: "シェフ、レストラン、食品ブランドが、それぞれの半球の旬に合わせてルバーブを祝うための、暦の定点を。" },
        { title: "農業生物多様性", text: "次の世紀へルバーブをつなぐ、品種・栽培の知識・研究への注目を集めます。" },
      ],
    },
    proposal: {
      kicker: "私たちの提案",
      para: "イニシアチブは4つのフェーズで進みます。各フェーズは公開の成果物——調査、書面の提案書、賛同者名簿、キャンペーンの枠組み——を生み出し、完成次第このサイトで公開します。",
      artifactLabel: "現在の成果物",
      artifact: "世界ルバーブの日 提案書 — 調査中。完成後に公開します。",
      phases: [
        { p: "フェーズ1", t: "調査と提案", d: "ルバーブの歴史、文化、生産地域、収穫時期、ふさわしい日程について生産者・団体・研究者にヒアリングし、「世界ルバーブの日 提案書」を公開します。" },
        { p: "フェーズ2", t: "国際的な賛同", d: "生産者、大学、農業団体、食品企業、シェフ、レストランに賛同を呼びかけます。名前は正式な同意がある場合のみ公開されます。" },
        { p: "フェーズ3", t: "各国支部 / カントリー代表", d: "各国オーガナイザーを募ります——例: 世界ルバーブの日 日本、英国、ポーランド。WRAとの関係を明確に公開した上で進めます。" },
        { p: "フェーズ4", t: "グローバルキャンペーン", d: "SNSキャンペーン、農家イベント、レストランフェア、商品キャンペーン、学校・大学のプログラム、栽培イベント、レシピ・写真コンテスト——世界規模で。" },
      ],
    },
    process: {
      kicker: "制定プロセス — 完全に透明に",
      title: "7つのステップ。すべて公開で、説明責任を果たす。",
      steps: [
        { t: "グローバル協議", d: "世界各国の生産者・団体・研究者へのヒアリング: 歴史、文化、生産地域、収穫時期、既存のイベント。", status: "準備中" },
        { t: "日程の選定", d: "各半球の収穫時期と、各国の既存の伝統を尊重する日を選びます。", status: "今後" },
        { t: "提案書の公開", d: "世界ルバーブの日 提案書——レビューのため、このサイトで公開します。", status: "今後" },
        { t: "国際的な賛同", d: "生産者、大学、農業団体、食品企業、シェフからの正式な支持。", status: "今後" },
        { t: "グローバルキャンペーン", d: "協調イベント: 農家の日、レストランフェア、コンテスト、学校・大学のプログラム。", status: "今後" },
        { t: "WRA公式認定", d: "ガバナンス構造の確立後、WRAによる正式な採択。", status: "今後" },
        { t: "より広い国際的承認", d: "より広範な国際機関・農業機関による承認を目指します。", status: "今後" },
      ],
      active: "準備中", upcoming: "今後",
      footer: "各ステップの達成内容は、達成され次第ここで公開します。",
    },
    organizer: {
      kicker: "カントリーオーガナイザーになる",
      titleA: "この日を、", titleAccent: "あなたの国へ。",
      para: "カントリーオーガナイザーは、世界ルバーブの日をそれぞれの国で主導します——イベント、パートナー、広報。ポジションはすべての国に開かれており、WRAが正式に認定し、その関係を公開します。",
      examples: ["世界ルバーブの日 – 日本", "世界ルバーブの日 – 英国", "世界ルバーブの日 – ポーランド"],
      open: "ポジション公募中",
      cta: "関心を表明する",
      events: { label: "世界のイベント", title: "公式イベントは、まだありません。", text: "最初の協調イベントは、グローバルキャンペーンのフェーズで計画されます。農家イベント、レストランフェア、レシピコンテスト、教育プログラムは、確定したものだけをここに掲載します。" },
      supporters: { label: "グローバル賛同者", title: "公式賛同者: 0名。", text: "賛同者の名前・国・組織・役職は、正式な書面の同意があってから初めてここに表示されます。名簿は空から始まり——公開の場で成長していきます。" },
      resources: { label: "世界ルバーブの日 リソース", title: "オーガナイザーツールキット — 準備中。", text: "ビジュアルアイデンティティ、ポスターテンプレート、イベントガイド、プレス資料を、カントリーオーガナイザー向けにここで公開します。" },
    },
    support: {
      kicker: "支援する方法",
      titleA: "この日に、", titleAccent: "あなたの名前を。",
      para: "生産者、大学、農業団体、食品企業、シェフ、レストランの皆さん——世界ルバーブの日の制定への賛同を表明してください。ご同意いただいた場合にのみ、お名前は公開名簿に加わります。同意なく公開することは、決してありません。",
      formTitle: "世界ルバーブの日を支援 — 賛同の表明",
      ph: { name: "お名前 *", email: "メールアドレス *", country: "国", org: "所属組織", position: "役職・立場" },
      consent: "WRAによる正式な確認後、賛同者として私の名前・国・組織・役職が公開されることに同意します。",
      submit: "世界ルバーブの日を支援", submitting: "送信中…",
      thanks: "ありがとうございます",
      successBase: "世界ルバーブの日への賛同が記録されました。",
      successConsent: " ご同意いただいたため、賛同が正式に確認され次第、グローバル賛同者ウォールにお名前が掲載される場合があります。",
      successNoConsent: " お名前が公開されることはありません。",
      toastOk: "賛同を記録しました。",
      toastErr: "送信に失敗しました。もう一度お試しください。",
    },
  },
  transparency: {
    kicker: "透明性とガバナンス",
    h1a: "今は小さい。", h1b: "誠実さは、常に。",
    para: "WRAは2026年に創設された、2名のイニシアチブです。私たちはこの小ささを「約束」として扱います。このページ——そしてこのサイト——のすべては組織をありのままに示し、現実が広がるときにだけ、拡張されます。",
    org: {
      kicker: "組織情報",
      facts: [
        ["団体名", "World Rhubarb Association (WRA)"],
        ["Founder / 代表", "須藤亘平(Kohei Sudo)"],
        ["コアチーム", "2名"],
        ["創設", "2026年"],
        ["法人格", "なし — 任意の国際イニシアチブ"],
        ["外部メンバー", "0名(創設ネットワーク構築中)"],
        ["海外メンバー", "0名"],
        ["公式パートナー", "0"],
      ],
    },
    gov: {
      kicker: "ガバナンス",
      para: "以下の構造は、成長するように設計されています——メンバー、代表、委員会、そして正式なガバナンスへ。各ポストはありのままに表示します: 就任済み、計画中、未設立。架空の名前が載ることは、決してありません。",
      filled: "就任済み", vacant: "空席",
      roles: [
        { role: "Founder / エグゼクティブディレクター", holder: "須藤亘平(Kohei Sudo)", filled: true },
        { role: "諮問委員会", holder: "未設立", filled: false },
        { role: "理事会", holder: "未設立", filled: false },
        { role: "研究委員会", holder: "計画中", filled: false },
        { role: "生産者委員会", holder: "計画中", filled: false },
        { role: "世界ルバーブの日委員会", holder: "計画中", filled: false },
        { role: "カントリー代表", holder: "任命者なし — ポジション公募中", filled: false },
      ],
    },
    docs: {
      kicker: "文書と出版物",
      items: [
        { name: "組織情報", status: "公開済み", note: "このページ" },
        { name: "リーダーシップ", status: "公開済み", note: "このページ" },
        { name: "メンバーシップポリシー", status: "準備中", note: "メンバーの掲載前に公開します" },
        { name: "ガバナンス憲章", status: "準備中", note: "創設ネットワークに続いて整備" },
        { name: "行動規範", status: "準備中", note: "ISO / FAO / IAIAの慣行を参照" },
        { name: "2026年度年次報告", status: "2027年第1四半期に公開予定", note: "最初の全会計年度" },
        { name: "財務情報", status: "公開予定", note: "初回の年次報告とともに" },
        { name: "世界ルバーブの日 提案書", status: "調査中", note: "完成後に公開します" },
        { name: "研究情報源", status: "継続中", note: "ナレッジハブの記事ごとに引用" },
      ],
    },
    manifesto: {
      kicker: "誇張ゼロのマニフェスト",
      title: "信頼こそが、私たちの唯一の成長戦略。",
      para: "2人の組織は、架空の規模から信頼を借りることはできません。だからWRAは逆を行きます。正確な規模を公開し、すべてのページの正確さそのものを、評判に変えていくのです。",
      principles: [
        "架空のメンバー、国、パートナー、賛同者は——決して作りません。",
        "データが存在しない場所には「データなし」と表示します。",
        "名前は、正式で文書化された同意がある場合のみ公開します。",
        "世界ルバーブの日は、正式に制定されるまで「提案」として提示します。",
        "このサイトのすべての数字は、実在する現在の事実にたどれます。",
      ],
    },
    models: {
      kicker: "参考モデル",
      para: "WRAの組織設計、透明性の実践、知識の公開は、確立された国際機関をモデルにしています。",
      items: [
        { name: "ISO", desc: "公開されているメンバー・委員会・ガバナンス構造。", url: "https://www.iso.org/structure.html" },
        { name: "FAO", desc: "公開された倫理・行動・利益相反ポリシー。", url: "https://www.fao.org/ethics/policies/en" },
        { name: "IAIA", desc: "ガバナンス、財務、年次報告による透明性。", url: "https://iaia.org/transparency/" },
        { name: "英国王立園芸協会(RHS)", desc: "体系的で、情報源の裏付けがある園芸知識。", url: "https://www.rhs.org.uk/vegetables/rhubarb/grow-your-own" },
      ],
      visit: "参考先を見る",
    },
    contact: {
      kicker: "正式なお問い合わせ",
      para: "メンバーシップ、ガバナンス、プレスに関するお問い合わせは、メインページのコンタクトフォームをご利用ください。すべてのお問い合わせに、創設チームが直接お答えします。",
      cta: "WRAに問い合わせる",
    },
  },
};
